/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled/macro";
import * as colors from "../../../styles/colors";

/* ════════════════════════════════════════════════════════════
   Shared OB/GYN Tab Components
   Uniform styling for all Dashboard tab bars.
   ════════════════════════════════════════════════════════════ */

const TAB_COLOR = colors.blue; /* #3871B7 — single accent for all tabs */

/* ─── Tab Bar Container ─────────────────────────────────── */
export const ObGynTabBar = styled.div({
    display: "flex",
    gap: "4px",
    background: "#fff",
    borderRadius: "10px",
    padding: "4px",
    marginBottom: "16px",
    border: `1px solid ${colors.gray20}`,
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
    overflowX: "auto",
});

/* ─── Tab Button ────────────────────────────────────────── */
export const ObGynTabBtn = styled.button(({ active = false }) => ({
    flex: "0 0 auto",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    padding: "9px 16px",
    borderRadius: "8px",
    border: "none",
    fontSize: "0.82rem",
    fontWeight: active ? 600 : 400,
    background: active ? TAB_COLOR : "transparent",
    color: active ? "#fff" : "#555",
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "all 0.15s ease",
    "&:hover": active
        ? {}
        : { background: "rgba(56,113,183,0.06)" },
}));

/* ─── Tab Badge (count pill) ────────────────────────────── */
export const ObGynTabBadge = styled.span(({ active = false }) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "20px",
    height: "20px",
    borderRadius: "10px",
    padding: "0 6px",
    fontSize: "0.7rem",
    fontWeight: 700,
    background: active ? "rgba(255,255,255,0.25)" : "#e0e0e0",
    color: active ? "#fff" : "#555",
    lineHeight: 1,
}));
